import React, { useState, useEffect } from "react";
import { getSubcategories }  from './databaseCalls.js'
import DynamicIcon from './DynamicIcon';



const pictograms= [
{id:1, name: "Berge", url: "https://www.seminargo.at/wp-content/uploads/2023/04/Berge_weiss_100px.svg"},
{id:2, name: "Burg", url: "https://www.seminargo.at/wp-content/uploads/2023/04/Burg_weiss_100px.svg"},
{id:3, name: "Event", url: "https://www.seminargo.at/wp-content/uploads/2023/04/Event_weiss_100px.svg"},
{id:4, name: "Garten", url: "https://www.seminargo.at/wp-content/uploads/2023/04/Garten_weiss_100px.svg"},
{id:5, name: "Gastronomie", url: "https://www.seminargo.at/wp-content/uploads/2023/04/Gastronomie_weiss_100px.svg"},
{id:6, name: "Hochzeit", url: "https://www.seminargo.at/wp-content/uploads/2023/04/Hochzeit_weiss_100px.svg"},
{id:7, name: "Luxus", url: "https://www.seminargo.at/wp-content/uploads/2023/04/Luxus_weiss_100px.svg"},
{id:8, name: "Natur", url: "https://www.seminargo.at/wp-content/uploads/2023/04/Natur_weiss_100px.svg"},
{id:9, name: "Qualität", url: "https://www.seminargo.at/wp-content/uploads/2023/04/Qualitaet_weiss_100px.svg"},
{id:10, name: "Schulung", url: "https://www.seminargo.at/wp-content/uploads/2023/04/Schulung_weiss_100px-1.svg"},
{id:11, name: "Stadt", url: "https://www.seminargo.at/wp-content/uploads/2023/04/Stadt_weiss_100px.svg"},
{id:12, name: "Sport", url: "https://www.seminargo.at/wp-content/uploads/2023/04/Sport_weiss_100px.svg"},
{id:13, name: "Team", url: "https://www.seminargo.at/wp-content/uploads/2023/04/Team_weiss_100px.svg"},
{id:14, name: "Technologie", url: "https://www.seminargo.at/wp-content/uploads/2023/05/Technologie_weiss_100px.svg"},
{id:15, name: "Verkehrsgünstig", url: "https://www.seminargo.at/wp-content/uploads/2023/04/Verkehrsguenstig_weiss_100px.svg"},
{id:16, name: "Weihnachten", url: "https://www.seminargo.at/wp-content/uploads/2023/04/Weihnachten_weiss_100px.svg"},
{id:17, name: "Wellness", url: "https://www.seminargo.at/wp-content/uploads/2023/04/Wellness_weiss_100px.svg"},
{id:18, name: "Burgenland", url: "https://www.seminargo.at/wp-content/uploads/2023/05/BGLD_weiss_100px.svg"},
{id:19, name: "Deutschland", url: ""},
{id:20, name: "Kärnten", url: "https://www.seminargo.at/wp-content/uploads/2023/05/KTN_weiss_100px.svg"},
{id:21, name: "Niederösterreich", url: "https://www.seminargo.at/wp-content/uploads/2023/05/NOe_weiss_100px.svg"},
{id:22, name: "Oberösterreich", url: "https://www.seminargo.at/wp-content/uploads/2023/05/OOe_weiss_100px.svg"},
{id:23, name: "Salzburg", url: "https://www.seminargo.at/wp-content/uploads/2023/05/SBG_weiss_100px.svg"},
{id:24, name: "Steiermark", url: "https://www.seminargo.at/wp-content/uploads/2023/05/STMK_weiss_100px.svg"},
{id:25, name: "Tirol", url: "https://www.seminargo.at/wp-content/uploads/2023/05/T_weiss_100px.svg"},
{id:26, name: "Vorarlberg", url: "https://www.seminargo.at/wp-content/uploads/2023/05/VBG_weiss_100px.svg"},
{id:27, name: "Wien", url: "https://www.seminargo.at/wp-content/uploads/2023/05/W_weiss_100px.svg"},
{id:28, name: "am Wasser", url: "https://www.seminargo.at/wp-content/uploads/2023/04/AmWasser_weiss_100px.svg"},
{id:29, name: "in der Nähe", url: "https://www.seminargo.at/wp-content/uploads/2023/04/InDerNaehe_weiss_100px.svg"},
{id:30, name: "Teamkochen", url: "https://www.seminargo.at/wp-content/uploads/2023/05/Teamkochen2_weiss_100px.svg"},
]

const Carousel = ({windowWidth}) => {
const itemsPerPage = Number(`${windowWidth > 900 ? 3 : windowWidth > 500 ? 2 : 1}`)
const itemsPerRow = Number(`${windowWidth > 900 ? 3 : windowWidth > 500 ? 2 : 1}`)
// const Carousel = ({ items }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [clusterCats, setClusterCats] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    getSubcategories(0)
      .then(data => {
        setClusterCats(data);
        console.log(data)
        setIsLoading(false);
      })
      .catch(err => {
        setError(err);
        setIsLoading(false);
      });
  }, []);

  const neededCats = clusterCats.filter(cat => cat.databaseId > 3000 || [18, 10, 9, 257, 260, 305, 433, 5, 4].includes(cat.databaseId));
  neededCats.forEach (item => {
    const pictogram = pictograms.find(pictogram => pictogram.name === item.name.replace('Seminarhotels', '').replace('Seminarhotel', '').replace('|', '').trim())
  
    item.imageUrl = pictogram ? 
    pictogram.url.length > 0 ? pictogram.url :
    "https://www.seminargo.at/wp-content/uploads/2023/03/seminargo-logo-white.svg" :
    "https://www.seminargo.at/wp-content/uploads/2023/03/seminargo-logo-white.svg"
    
  // item.imageUrl === undefined ? item.imageUrl = "https://www.seminargo.at/wp-content/uploads/2023/03/seminargo-logo-white.svg" : null
})

// const clusters = neededCats.map((cluster, index) => 
// <div key={index} css={singleClusterBoxStyles}><a href={cluster.link}>{cluster.name}</a></div>)



  const totalPages = Math.ceil(neededCats.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const visibleItems = neededCats.slice(startIndex, endIndex);

  const handlePrevious = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleNext = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const renderRows = () => {
    const rows = [];

    for (let i = 0; i < visibleItems.length; i += itemsPerRow) {
      const rowItems = visibleItems.slice(i, i + itemsPerRow);
      rows.push(
        // <div className="row" key={i}>
        //   {rowItems.map((item) => (
        //     <a href={item.link} key={item.databaseId}>
        //     <div className="item" key={item.databaseId}>
        //       <span>{item.name}</span>
        //     </div>
        //     </a>
        //   ))}
        // </div>
        <div className="textRow" key={i}>
            {error && <div>{error}</div>}
           {isLoading && <div>Loading...</div>}
        {rowItems.map((item) => (
          <div className="text-wrapper" key={item.databaseId}>
          {/* <a href={item.link}> */}
          <a href={`https://www.seminargo.at/themen-und-die-bundeslaender/?category1=18&category2=${item.databaseId}`}>
          <div 
          className="item"
          style={{backgroundImage: `url(${item.imageUrl})`, backgroundSize: '50% 50%', backgroundRepeat: 'no-repeat', backgroundPosition: 'center top 3rem'}} 
          key={item.databaseId}
          >
            {/* <img src={item.imageUrl} alt={item.title.rendered} /> */}
            <span>{item.name}</span>
          </div>
          </a>
          </div>
        ))}
      </div>
      );
    }

    return rows;
  };

  return (
    <div className="carousel">
      {renderRows()}
      <div className="controls">
        <button aria-label="previous" disabled={currentPage === 1} onClick={handlePrevious}>
          {/* Prev */}
          <DynamicIcon icon={"arrowCircleLeft"} id="icon"/>
        </button>
        <button aria-label="next" disabled={currentPage === totalPages} onClick={handleNext}>
          {/* Next */}
          <DynamicIcon icon={"arrowCircleRight"} id="icon"/>
        </button>
      </div>
    </div>
  );
};

export default Carousel;

